import productFunctions from './serie-design/serie-product-functions';

document.addEventListener("DOMContentLoaded", () => {
    productFunctions.init();
});